import { isFetchResultSuccessful } from '../../models/FetchResult';
import { OccupationFilterValues } from '../../models/OccupationOverview/OccupationOverview';
import { getOccupationOverviewApiCall } from '../../models/OccupationOverview/OccupationOverviewService';
import { transformToPagination } from '../../models/Pagination';
import { ReducerGetter, TypedDispatch } from '../store';
import {
    setError,
    setIsLoading,
    setOccupationOverview,
    setPagination,
} from './occupationOverview';

export const fetchOccupationOverview = (
    candidateUuid: string,
    skills: string[],
    activeFilterValues: OccupationFilterValues,
) => async (dispatch: TypedDispatch): Promise<void> => {
    dispatch(setIsLoading(true));
    dispatch(setError(''));

    try {
        const occupationOverviewResponse = await getOccupationOverviewApiCall(candidateUuid, skills, activeFilterValues);

        if (!isFetchResultSuccessful(occupationOverviewResponse)) {
            dispatch(setError(occupationOverviewResponse.error));
            return;
        }

        const occupationOverview = occupationOverviewResponse.data;

        const currentPage = activeFilterValues.pageNumber;
        const pagination = transformToPagination(occupationOverview.occupations.length, currentPage, activeFilterValues.pageSize);

        dispatch(setOccupationOverview(occupationOverview));
        dispatch(setPagination(pagination));
    } catch (error) {
        console.error('[fetchOccupationOverview]', error);
        dispatch(setError(error as string));
    } finally {
        dispatch(setIsLoading(false));
    }
};

export const setOccupationOverviewPagination = (currentPage: number) => async (dispatch: TypedDispatch, getState: ReducerGetter): Promise<void> => {
    const { occupationOverviewReducer } = getState();
    const { pagination } = occupationOverviewReducer;

    if (pagination) {
        await dispatch(setPagination({
            ...pagination,
            currentPage,
        }));
    }
};
